// extracted by mini-css-extract-plugin
export default {"form":"details-modal_form__iBEkR"};